/**
 * Registre des traductions et helpers i18n de l'application
 *
 * Responsabilités:
 * - Centralise les messages de traduction par locale
 * - Définit la liste des langues supportées
 * - Résout la locale initiale (localStorage ou navigateur)
 *
 * Ne gère pas:
 * - L'injection du plugin Vue I18n (déléguée à main.ts)
 * - La mise à jour de la locale en runtime (déléguée à UseI18n)
 * - La traduction des composants (déléguée aux vues/composants)
 *
 * Dépendances: messages JSON de traductions
 */
import fr from './fr.json'
import en from './en.json'
import type { Locale, LocaleMessages } from '@/types/i18n'

export const messages: LocaleMessages = {
  fr,
  en,
}

export const supportedLocales: Locale[] = ['fr', 'en']

export const localeStorageKey = 'app-locale'

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'fr' || value === 'en'
}

export function resolveInitialLocale(): Locale {
  if (typeof window === 'undefined') {
    return 'fr'
  }

  const storedLocale = window.localStorage.getItem(localeStorageKey)
  if (isLocale(storedLocale)) {
    return storedLocale
  }

  const navigatorLocale = window.navigator?.language?.toLowerCase() ?? ''
  if (navigatorLocale.startsWith('en')) {
    return 'en'
  }

  return 'fr'
}
